import queryString from "query-string";
import Bowser from "bowser";

import { getPortfolioSessionUserId } from "../redux/reducers/Common";

export const isSmallScreen = window.innerWidth <= 760 || window.innerHeight <= 760;

const isMobileCheck = (function(a) {
  if (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
      a
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      a.substr(0, 4)
    )
  ) {
    const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      a.toLowerCase()
    );

    if (isTablet === true) {
      return isSmallScreen;
    } else {
      return true;
    }
  }

  return false;
})(navigator.userAgent || navigator.vendor || window.opera);

window.kuberaOpen = (url, target) => {
  const openedWindow = window.open(url, target);
  if (openedWindow) {
    // If it's an external url and window is blocked then handle error at this line
    try {
      openedWindow.portfolioUserId = getPortfolioSessionUserId();
    } catch (err) {
      console.log(err);
    }
  }
  return openedWindow;
};

export const isPwaApp = () => {
  // For iOS
  if (window.navigator.standalone) return true;
  // For Android
  if (window.matchMedia("(display-mode: standalone)").matches) return true;
  return false;
};

export const getHashParams = location => {
  return queryString.parse(location.hash);
};

export const getHashParamsFromString = hash => {
  return queryString.parse(hash);
};

const PLACEHOLDER_HASH_PARAM_VALUES = ["undefined", "null", ""];

export const getSanitizedHashParams = location => {
  const params = getHashParams(location);
  for (const key of Object.keys(params)) {
    if (params[key] === null || PLACEHOLDER_HASH_PARAM_VALUES.includes(params[key])) {
      delete params[key];
    }
  }
  return params;
};

export const toHashParamString = hashParamsObject => {
  return queryString.stringify(hashParamsObject);
};

export const getForceErrorFlag = (location = window.location) => {
  if (process.env.REACT_APP_ENV === "prod") return 0;
  const urlHashParams = getHashParams(location);
  return Number(urlHashParams["forceError"]);
};

export const forceReloadAndBypassCache = e => {
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.get("forceBypassCache") && e?.type !== "click") {
      return;
    }
    url.searchParams.set(
      "forceBypassCache",
      Math.random()
        .toString(36)
        .substring(2)
    );
    window.location.replace(url.toString());
  } catch (error) {
    window.location.reload();
  }
};

const PARSED_PARAMS_CACHE_LIMIT = 500;
const parsedParamsCache = new Map();

export const parseParams = params => {
  let parsed = parsedParamsCache.get(params);
  if (parsed === undefined) {
    parsed = Object.freeze(queryString.parse(params));
    if (parsedParamsCache.size >= PARSED_PARAMS_CACHE_LIMIT) {
      parsedParamsCache.clear();
    }
    parsedParamsCache.set(params, parsed);
  }
  return parsed;
};

export const isOsx = () => {
  return navigator.platform.toLowerCase().indexOf("mac") > -1;
};

export function getBaseFontSizePxAsCssClamp(baseFontSize = 16, maxFontSize = 64) {
  return `clamp(${baseFontSize}px, ${(baseFontSize / window.screen.width) * 100}vw, ${maxFontSize}px)`;
}

export function getBaseFontSizePxSimilarToClamp(baseFontSize = 16, maxFontSize = 64) {
  return baseFontSize + "px";
  // const vwFactor = (baseFontSize / window.screen.width) * 100;

  // // Convert that vw factor into pixels for current viewport width
  // const vwValue = (vwFactor / 100) * window.innerWidth;

  // // Clamp the result
  // const fontSizePx = Math.min(Math.max(vwValue, baseFontSize), maxFontSize);

  // return fontSizePx + "px";
}

export const isMobile = () => {
  return isMobileCheck;
};

export const getMetaKeyName = () => {
  if (isOsx() === true) {
    return "Cmd";
  }
  return "Ctrl";
};

export const isMetaKeyPressed = e => {
  if (isOsx() === true) {
    return e.metaKey === true;
  }
  return e.ctrlKey === true;
};

export const getCountryNameFromISOCode = code => {
  var isoCountries = {
    AF: "Afghanistan",
    AX: "Aland Islands",
    AL: "Albania",
    DZ: "Algeria",
    AS: "American Samoa",
    AD: "Andorra",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarctica",
    AG: "Antigua And Barbuda",
    AR: "Argentina",
    AM: "Armenia",
    AW: "Aruba",
    AU: "Australia",
    AT: "Austria",
    AZ: "Azerbaijan",
    BS: "Bahamas",
    BH: "Bahrain",
    BD: "Bangladesh",
    BB: "Barbados",
    BY: "Belarus",
    BE: "Belgium",
    BZ: "Belize",
    BJ: "Benin",
    BM: "Bermuda",
    BT: "Bhutan",
    BO: "Bolivia",
    BA: "Bosnia And Herzegovina",
    BW: "Botswana",
    BV: "Bouvet Island",
    BR: "Brazil",
    IO: "British Indian Ocean Territory",
    BN: "Brunei Darussalam",
    BG: "Bulgaria",
    BF: "Burkina Faso",
    BI: "Burundi",
    KH: "Cambodia",
    CM: "Cameroon",
    CA: "Canada",
    CV: "Cape Verde",
    KY: "Cayman Islands",
    CF: "Central African Republic",
    TD: "Chad",
    CL: "Chile",
    CN: "China",
    CX: "Christmas Island",
    CC: "Cocos (Keeling) Islands",
    CO: "Colombia",
    KM: "Comoros",
    CG: "Congo",
    CD: "Congo, Democratic Republic",
    CK: "Cook Islands",
    CR: "Costa Rica",
    CI: "Cote D'Ivoire",
    HR: "Croatia",
    CU: "Cuba",
    CY: "Cyprus",
    CZ: "Czech Republic",
    DK: "Denmark",
    DJ: "Djibouti",
    DM: "Dominica",
    DO: "Dominican Republic",
    EC: "Ecuador",
    EG: "Egypt",
    SV: "El Salvador",
    GQ: "Equatorial Guinea",
    ER: "Eritrea",
    EE: "Estonia",
    ET: "Ethiopia",
    FK: "Falkland Islands (Malvinas)",
    FO: "Faroe Islands",
    FJ: "Fiji",
    FI: "Finland",
    FR: "France",
    GF: "French Guiana",
    PF: "French Polynesia",
    TF: "French Southern Territories",
    GA: "Gabon",
    GM: "Gambia",
    GE: "Georgia",
    DE: "Germany",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Greece",
    GL: "Greenland",
    GD: "Grenada",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernsey",
    GN: "Guinea",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HT: "Haiti",
    HM: "Heard Island & Mcdonald Islands",
    VA: "Holy See (Vatican City State)",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hungary",
    IS: "Iceland",
    IN: "India",
    ID: "Indonesia",
    IR: "Iran, Islamic Republic Of",
    IQ: "Iraq",
    IE: "Ireland",
    IM: "Isle Of Man",
    IL: "Israel",
    IT: "Italy",
    JM: "Jamaica",
    JP: "Japan",
    JE: "Jersey",
    JO: "Jordan",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KI: "Kiribati",
    KR: "Korea",
    KW: "Kuwait",
    KG: "Kyrgyzstan",
    LA: "Lao People's Democratic Republic",
    LV: "Latvia",
    LB: "Lebanon",
    LS: "Lesotho",
    LR: "Liberia",
    LY: "Libyan Arab Jamahiriya",
    LI: "Liechtenstein",
    LT: "Lithuania",
    LU: "Luxembourg",
    MO: "Macao",
    MK: "Macedonia",
    MG: "Madagascar",
    MW: "Malawi",
    MY: "Malaysia",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malta",
    MH: "Marshall Islands",
    MQ: "Martinique",
    MR: "Mauritania",
    MU: "Mauritius",
    YT: "Mayotte",
    MX: "Mexico",
    FM: "Micronesia, Federated States Of",
    MD: "Moldova",
    MC: "Monaco",
    MN: "Mongolia",
    ME: "Montenegro",
    MS: "Montserrat",
    MA: "Morocco",
    MZ: "Mozambique",
    MM: "Myanmar",
    NA: "Namibia",
    NR: "Nauru",
    NP: "Nepal",
    NL: "Netherlands",
    AN: "Netherlands Antilles",
    NC: "New Caledonia",
    NZ: "New Zealand",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Norfolk Island",
    MP: "Northern Mariana Islands",
    NO: "Norway",
    OM: "Oman",
    PK: "Pakistan",
    PW: "Palau",
    PS: "Palestinian Territory, Occupied",
    PA: "Panama",
    PG: "Papua New Guinea",
    PY: "Paraguay",
    PE: "Peru",
    PH: "Philippines",
    PN: "Pitcairn",
    PL: "Poland",
    PT: "Portugal",
    PR: "Puerto Rico",
    QA: "Qatar",
    RE: "Reunion",
    RO: "Romania",
    RU: "Russian Federation",
    RW: "Rwanda",
    BL: "Saint Barthelemy",
    SH: "Saint Helena",
    KN: "Saint Kitts And Nevis",
    LC: "Saint Lucia",
    MF: "Saint Martin",
    PM: "Saint Pierre And Miquelon",
    VC: "Saint Vincent And Grenadines",
    WS: "Samoa",
    SM: "San Marino",
    ST: "Sao Tome And Principe",
    SA: "Saudi Arabia",
    SN: "Senegal",
    RS: "Serbia",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapore",
    SK: "Slovakia",
    SI: "Slovenia",
    SB: "Solomon Islands",
    SO: "Somalia",
    ZA: "South Africa",
    GS: "South Georgia And Sandwich Isl.",
    ES: "Spain",
    LK: "Sri Lanka",
    SD: "Sudan",
    SR: "Suriname",
    SJ: "Svalbard And Jan Mayen",
    SZ: "Swaziland",
    SE: "Sweden",
    CH: "Switzerland",
    SY: "Syrian Arab Republic",
    TW: "Taiwan",
    TJ: "Tajikistan",
    TZ: "Tanzania",
    TH: "Thailand",
    TL: "Timor-Leste",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinidad And Tobago",
    TN: "Tunisia",
    TR: "Turkey",
    TM: "Turkmenistan",
    TC: "Turks And Caicos Islands",
    TV: "Tuvalu",
    UG: "Uganda",
    UA: "Ukraine",
    AE: "United Arab Emirates",
    GB: "United Kingdom",
    US: "United States",
    UM: "United States Outlying Islands",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VU: "Vanuatu",
    VE: "Venezuela",
    VN: "Viet Nam",
    VG: "Virgin Islands, British",
    VI: "Virgin Islands, U.S.",
    WF: "Wallis And Futuna",
    EH: "Western Sahara",
    YE: "Yemen",
    ZM: "Zambia",
    ZW: "Zimbabwe"
  };
  return isoCountries[(code || "").toUpperCase()];
};

/*************** Browser/OS detection methods ************************/
const browser = Bowser.getParser(window.navigator.userAgent);
const isBrave = navigator.brave && typeof navigator.brave.isBrave === "function";

export const getOsDetails = () => {
  return {
    name: browser.getOSName(),
    version: browser.getOSVersion()
  };
};

export const getBrowserNameInLowerCase = () => {
  if (isBrave) {
    return "brave";
  }

  if (isEdge()) {
    return "edge";
  }

  return browser.getBrowserName().toLocaleLowerCase();
};

export const isiOS9AndAbove = () => {
  return browser.getOSName() === "iOS" && parseInt(browser.getOSVersion(), 10) >= 9;
};

export const isChrome = () => {
  return browser.getBrowserName() === "Chrome" && !isBrave;
};

export const isEdge = () => {
  return browser.getBrowserName().toLocaleLowerCase() === "microsoft edge" && !isBrave;
};

// iOS detection
export const isiOS = () => {
  return browser.getOSName() === "iOS";
};

// iOS Safari browser detection
export const isiOSSafari = () => {
  return browser.getBrowserName() === "Safari" && !isBrave;
};

export const isTablet = () => {
  return false; // @TODO: Returning false temporarily to fix the issue with biometric
  // eslint-disable-next-line no-unreachable
  const device = browser.getPlatformType();
  return (
    device === "tablet" ||
    browser.getUA().includes("iPad") ||
    (browser.getOSName() === "macOS" && browser.getUA().includes("Safari") && window.screen.width <= 1024)
  );
};

/*************************************************************************/

export const isSafariOnMacOS = () => {
  return browser.getOSName()?.toLowerCase() === "macos" && browser.getBrowserName()?.toLowerCase() === "safari";
};

export const printElement = divName => {
  const isSafariBrowser = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  if (isSafariBrowser) {
    const popup = window.kuberaOpen("", "_blank", "width=1,height=1");
    popup.addEventListener("afterprint", event => {
      popup.close();
    });
    const content = document.getElementById(divName);
    popup.document.head.innerHTML = document.head.innerHTML;
    popup.document.body.innerHTML = content.innerHTML;
    setTimeout(() => {
      popup.print();
      setTimeout(() => {
        popup.close();
      });
    });
  } else {
    window.print();
  }
};

export const printWithDelay = () => {
  requestAnimationFrame(() => {
    setTimeout(() => {
      window.print();
    }, 1000);
  });
};
